import { Linkedin, Instagram, Facebook, Mail, Phone, Twitter, Github, Globe } from "lucide-react";
import { useSocialLinks } from "@/hooks/usePortfolio";

const map = { linkedin: Linkedin, instagram: Instagram, facebook: Facebook, mail: Mail, phone: Phone, twitter: Twitter, github: Github, website: Globe };

export const SocialLinks = ({ variant = "floating" }) => {
  const { data: apiLinks, isLoading, error } = useSocialLinks();

  if (isLoading || error || !apiLinks) return null;

  const links = apiLinks.filter((l) => l.profileUrl).sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <>
      {variant === "floating" ? (
        <div className="fixed left-5 top-1/2 -translate-y-1/2 z-30 hidden xl:flex flex-col gap-3" data-testid="social-floating">
          {links.map((l) => {
            const extractedIconName = l.iconUrl?.split(' ').pop()?.replace(/^fa-/, '')?.toLowerCase();
            const mapKey = extractedIconName || l.platformName?.toLowerCase();
            const Icon = map[mapKey] || Globe;
            return (
              <a
                key={l.id}
                href={l.profileUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={l.platformName}
                data-testid={`social-${mapKey}`}
                className="w-11 h-11 rounded-full glass flex items-center justify-center hover:border-[hsl(var(--gold))] hover:text-[hsl(var(--gold-deep))] dark:hover:text-[hsl(var(--gold-light))] transition-all hover:-translate-y-1"
              >
                <Icon className="w-4 h-4" />
              </a>
            );
          })}
          <div className="hairline-vertical h-12 mx-auto mt-2" />
        </div>
      ) : (
        <div className="flex items-center gap-3 flex-wrap">
          {links.map((l) => {
            const extractedIconName = l.iconUrl?.split(' ').pop()?.replace(/^fa-/, '')?.toLowerCase();
            const mapKey = extractedIconName || l.platformName?.toLowerCase();
            const Icon = map[mapKey] || Globe;
            return (
              <a
                key={l.id}
                href={l.profileUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={l.platformName}
                data-testid={`social-inline-${mapKey}`}
                className="w-10 h-10 rounded-full glass flex items-center justify-center hover:border-[hsl(var(--gold))] hover:text-[hsl(var(--gold-deep))] dark:hover:text-[hsl(var(--gold-light))] transition-all"
              >
                <Icon className="w-4 h-4" />
              </a>
            );
          })}
        </div>
      )}
    </>
  );
};
